import { Injectable } from '@angular/core';

import { RepositoryService } from '@_services/api/repository.service';
import { GeneratedOrganizationSaleCategoryApiService } from './organization-sale-category-api-generated.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationSaleCategoryApiService extends GeneratedOrganizationSaleCategoryApiService {
  constructor(repo: RepositoryService) {
    super(repo);
  }
}
